import Axios from "axios";

export class PepParentescoService {

    lista(params) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/pep-parentesco/lista?${queryParams}`).then(res => res.data);
    }

    nuevo(data) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/ficha/pep-parentesco/nuevo`, data).then(res => res.data);
    }

    editar(data) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/ficha/pep-parentesco/editar`, data).then(res => res.data);
    }

    eliminar(id, idp, opciones = {}) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/ficha/pep-parentesco/eliminar/${id}/${idp}`, { params: opciones }).then(res => res.data);
    }

    consulta(id, idp, opciones = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/pep-parentesco/consulta/${id}/${idp}`, { params: opciones }).then(res => res.data);
    }
}